import React from "react";
import "./Button.scss";
import { ButtonProps } from "./Button.types";

/**
 * Button Component
 */
const Button = ({
  primary = false,
  backgroundColor,
  size = "medium",
  onClick,
  label,
  disabled = false,
  height,
  width,
  className,
  onMouseOver,
  onMouseOut,
  iconPath,
  iconClass,
  iconContainerClass,
  iconDirection,
  displayDirection,
  dataTestId,
  tooltip,
}: ButtonProps) => {
  const mode = primary ? "alteon-button-primary" : "alteon-button-secondary";
  const disabledClass =
    disabled === false
      ? `alteon-button-${size} alteon-button ${mode} ${className}`
      : `alteon-button-${size} alteon-button alteon-button-disabled ${className}`;
  const passedIconClass = iconClass;
  return (
    <button
      type="button"
      data-testid={dataTestId ? dataTestId : "alteon-button-data-test-id"}
      title={tooltip ? tooltip : ""}
      className={disabledClass}
      style={{
        display: `${displayDirection}`,
        backgroundColor: `${backgroundColor}`,
        height: `${height}`,
        width: `${width}`,
      }}
      onClick={onClick}
      disabled={disabled}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      {iconPath && iconDirection === "left" && (
        <div
          className={`${iconContainerClass}`}
          style={{
            flexDirection: "row",
          }}
        >
          {typeof iconPath === "string" && (
            <img className={passedIconClass} src={iconPath} />
          )}
          {typeof iconPath !== "string" && iconPath}
        </div>
      )}
      <div>{label}</div>
      {iconPath && iconDirection === "right" && (
        <div
          className={`${iconContainerClass}`}
          style={{
            flexDirection: "row",
          }}
        >
          {typeof iconPath === "string" && (
            <img className={passedIconClass} src={iconPath} />
          )}
          {typeof iconPath !== "string" && iconPath}{" "}
        </div>
      )}
    </button>
  );
};

export default Button;
